<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span>Filtros</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-card-text>
            <v-row>
              <v-col>
                <v-menu
                  v-model="menuDataInicio"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dataInicioComp"
                      label="Data Início"
                      v-touch="dataInicio"
                      :error-messages="dataInicioErrors"
                      prepend-icon="mdi mdi-calendar"
                      readonly
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <button-datepicker v-model="dataInicio" @input="menuDataInicio = false" />
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  v-model="menuDataFim"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dataFimComp"
                      label="Data Fim"
                      v-touch="dataFim"
                      :error-messages="dataFimErrors"
                      prepend-icon="mdi mdi-calendar"
                      readonly
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <button-datepicker v-model="dataFim" @input="menuDataFim = false" />
                </v-menu>
              </v-col>
            </v-row>
            <v-radio-group v-model="tipo" row>
              <v-radio label="Vendas" value="V" />
              <v-radio label="Faturadas" value="F" />
              <v-radio label="Pendentes (Digitação)" value="D" />
            </v-radio-group>
            <v-autocomplete
              v-model="idVendedor"
              :items="vendedores"
              :search-input.sync="pesquisa"
              no-filter
              v-touch="idVendedor"
              :loading="pesquisando"
              item-text="nome"
              return-object
              label="Vendedor"
              clearable
              no-data-text="Nenhum vendedor encontrado"
              placeholder="Pesquise por nome ou número da matrícula (funcionários)"
              prepend-icon="mdi-database-search"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading">Gerar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import _ from "lodash";
import moment from "moment";
import ButtonDatepicker from '../components/ButtonDatepicker'
import number_format from '../lib/number_format';

export default {
  mixins: [validationMixin],
  components: {ButtonDatepicker},

  validations: {
    dataInicio: { required },
    dataFim: { required },
  },

  data() {
    return {
      dataInicio: moment().format('YYYY-MM-01'),
      dataFim: moment().format('YYYY-MM-DD'),
      menuDataInicio: false,
      menuDataFim: false,
      tipo: "V",
      idVendedor: {
        id: null,
        nome: null,
      },
      loading: false,
      pesquisando: false,
      pesquisa: null,
    };
  },

  computed: {
    dataInicioComp: {
      get() {
        if (!this.dataInicio) return "";
        return this.dataInicio
          .split("-")
          .reverse()
          .join("/");
      },
      set(val) {
        this.dataInicio = val || "";
      }
    },
    dataFimComp: {
      get() {
        if (!this.dataFim) return "";
        return this.dataFim
          .split("-")
          .reverse()
          .join("/");
      },
      set(val) {
        this.dataFim = val || "";
      }
    },
    dataInicioErrors() {
      const errors = [];
      if (!this.$v.dataInicio.$dirty) return errors;
      !this.$v.dataInicio.required &&
        errors.push(`Data Início é obrigatória`);
      return errors;
    },
    dataFimErrors() {
      const errors = [];
      if (!this.$v.dataFim.$dirty) return errors;
      !this.$v.dataFim.required &&
        errors.push(`Data Fim é obrigatória`);
      return errors;
    },
    ...mapState({
      vendedores: state => state.vendedor.vendedores
    })
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;

        const dados = await this.$store.dispatch("relatorio/gerarDadosVendas1", { data_inicio: this.dataInicio, data_fim: this.dataFim, tipo: this.tipo, id_vendedor: this.idVendedor ? this.idVendedor.id : null});

        dados.linhas = Object.keys(dados.linhas).map(key => { 
          const linha = dados.linhas[key]
          linha.data_inicio = moment(linha.data_inicio).format('DD/MM/YYYY');
          linha.valor_ordem = number_format(linha.valor_ordem);
          linha.valor_custos = number_format(linha.valor_custos);

          linha.terceiros = Object.keys(linha.terceiros).map(key => {
            const terceiro = linha.terceiros[key]
            terceiro.valor_terceiro = number_format(terceiro.valor_terceiro);

            return terceiro
          });

          linha.bvs = Object.keys(linha.bvs).map(key => {
            const bv = linha.bvs[key]
            bv.valor_bv = number_format(bv.valor_bv);

            return bv
          });

          linha.parcelas = linha.parcelas.map(parcela => {
            parcela.data_vencimento = moment(parcela.data_vencimento).format('DD/MM/YYYY');
            parcela.valor_parcela = number_format(parcela.valor_parcela);
            parcela.valor_comissao = number_format(parcela.valor_comissao);

            return parcela
          });
         
          return linha;
        });

        dados.total_liquido = number_format(dados.total_valor_ordem - dados.total_valor_custos - dados.total_valor_terceiros - dados.total_valor_bv - dados.total_valor_comissao);
        dados.total_valor_ordem = number_format(dados.total_valor_ordem);
        dados.total_valor_custos = number_format(dados.total_valor_custos);
        dados.total_valor_terceiros = number_format(dados.total_valor_terceiros);
        dados.total_valor_bv = number_format(dados.total_valor_bv);
        dados.total_valor_comissao = number_format(dados.total_valor_comissao);

        var titulo = ""
        switch(this.tipo) {
          case 'V': titulo = "RELATÓRIO DE VENDAS REALIZADAS"; break;
          case 'E': titulo = "RELATÓRIO DE VENDAS PENDENTES (DIGITAÇÃO)"; break;
          case 'F': titulo = "RELATÓRIO DE VENDAS FATURADO"; break;
        }

        const rel = await this.$store.dispatch("relatorio/gerar", {
          template: "rel-vendas.html",
          dados: {
            titulo: titulo,
            dados: {
              data_atual: moment().format('DD/MM/YYYY'),
              filters: { 
                data_inicio: this.dataInicioComp,
                data_fim: this.dataFimComp,
                nome_vendedor: this.idVendedor? this.idVendedor.nome : null
              },
              data: dados
            },
          },
        });

        const url = window.URL.createObjectURL(
          new Blob([rel.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.loading = false;
      }
    },
    pesquisarVendedores: _.debounce(async function() {
      this.pesquisando = true;
      await this.$store.dispatch("vendedor/listar", {
        pesquisa: this.pesquisa
      });
      this.pesquisando = false;
    }, 300)
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Relatório de Vendas"
    });
  },
  watch: {
    pesquisa() {
      this.pesquisarVendedores();
    }
  }
};
</script>
